// extracted by mini-css-extract-plugin
module.exports = {"r1v321y5":"r1v321y5","c833atb":"c833atb","d1uig2uw":"d1uig2uw","c1vejb9a":"c1vejb9a","p152tkos":"p152tkos"};